module.exports = __webpack_public_path__ + "assets/img/step8-2.72bd2ccc.png";